
<div class="report-page-root-container yearly-result-by-week-component-container ">
  <div class="page-content">
    <div class="page-header">
      <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width: 27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation"></path>
      </svg>
      <div class="title">
        {{ title }}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Year</mat-label>
                <mat-select placeholder="Select a year" formControlName="year" (selectionChange)="onYearChange()">
                  <!-- Show loading state while waiting for data -->

                  <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                    {{ fy.display_year }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <mat-radio-group formControlName="sort_order" class="radio-button" style="margin-left: 5px">
              <mat-label>Report Type</mat-label>
              <div class="options-container">
                <mat-radio-button *ngFor="let option of sortOptions" [value]="option.value">
                  {{ option.label }}
                </mat-radio-button>
              </div>
            </mat-radio-group>

            <div class="input-group" *ngIf="editForm.get('sort_order')?.value === 'consolidation'">
              <div>
                <mat-form-field appearance="fill" style="width: 190px">
                  <mat-label>Filterable by</mat-label>
                  <mat-select formControlName="filtered_by">
                    <mat-option value="region"> Region </mat-option>
                    <mat-option value="area_manager"> Area manager </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div></div>
            </div>

            <!-- <div class="list-container shops" *ngIf="editForm.get('sort_order')?.value === 'store'">
              <div class="header">
                <span>Shops ({{getSelectedCount(shopListData)}})</span>
                <div class="toggle-arrow-container">
                  <button mat-flat-button color="warn" class="btn-rest"
                    (click)="$event.stopPropagation();reset(shopListData);">Reset</button>
                
                </div>
              </div>

              <div class="list">
                <div class="item-list all">
                  <ng-container *ngFor="let item of shopListData">
                    <div *ngIf="!item.selected" class="list-item"
                      (click)="item.selected=!item.selected; onSelectionChange();">
                      <div class="name">
                        <span>{{item.item.name}}</span>
                      </div>
                      <div class="selection">
                        <mat-icon>chevron_right</mat-icon>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="item-list selected">
                  <ng-container *ngFor="let item of shopListData">
                    <div *ngIf="item.selected" class="list-item"
                      (click)="item.selected=!item.selected; onSelectionChange();">
                      <div class="name">
                        <span>{{item.item.name}}</span>
                      </div>
                      <div class="selection">
                        <mat-icon>chevron_left</mat-icon>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
               
            </div> -->
            <div class="list-row shops" *ngIf="editForm.get('sort_order')?.value === 'store'">
              <div class="header" (click)="isExpandedShop = !isExpandedShop">
                <div class="title-container">
                  <span class="title">Shops</span> <span class="count" *ngIf="selectedShopSourcesCount>0">[
                    {{selectedShopSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedShop">
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); showSelectedShopOnly = !showSelectedShopOnly"
                      [matTooltip]="showSelectedShopOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedShopOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllShop()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconShop() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedShop ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedShop" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter shops" formControlName="shopFilterAll" />
                      <button *ngIf="editForm.get('shopFilterAll')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('shopFilterAll')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredShopListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onShopSelectionChange()">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onShopSelectionChange()">
                          {{ item.item.name }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="list-row branch" *ngIf="editForm.get('sort_order')?.value === 'branch'">
              <div class="header" (click)="isExpandedBranch = !isExpandedBranch">
                <div class="title-container">
                  <span class="title">Branch</span> <span class="count" *ngIf="selectedBranchSourcesCount>0">[
                    {{selectedBranchSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedBranch">
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); showSelectedBranchOnly = !showSelectedBranchOnly"
                      [matTooltip]="showSelectedBranchOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedBranchOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllBranch()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconBranch() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedBranch ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedBranch" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Branch" formControlName="branchFilterAll" />
                      <button *ngIf="editForm.get('branchFilterAll')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('branchFilterAll')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredBranchListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onBrachSelectionChange()">
                        <mat-checkbox color="primary" [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onBrachSelectionChange()">
                          {{ item.item.branch }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="editForm.get('sort_order')?.value === 'consolidation'">
              <!-- <div class="list-container Region" *ngIf="editForm.get('filtered_by')?.value === 'Region'">
              <div class="header">
                <span>Regions ({{getSelectedCount(regionListData)}})</span>
                <div class="toggle-arrow-container">
                  <button mat-flat-button color="warn" class="btn-rest"
                    (click)="$event.stopPropagation();reset(regionListData);">Reset</button>
                  
                </div>
              </div>

              <div class="list">
                <div class="item-list all">
                  <ng-container *ngFor="let item of regionListData">
                    <div *ngIf="!item.selected" class="list-item"
                      (click)="item.selected=!item.selected; onSelectionChange();">
                      <div class="name">
                        <span>{{item.item.name}}</span>
                      </div>
                      <div class="selection">
                        <mat-icon>chevron_right</mat-icon>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="item-list selected">
                  <ng-container *ngFor="let item of regionListData">
                    <div *ngIf="item.selected" class="list-item"
                      (click)="item.selected=!item.selected; onSelectionChange();">
                      <div class="name">
                        <span>{{item.item.name}}</span>
                      </div>
                      <div class="selection">
                        <mat-icon>chevron_left</mat-icon>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
               </div> -->
              <div class="list-row Region" *ngIf="editForm.get('filtered_by')?.value === 'region'">
                <div class="header" (click)="isExpandedRegion = !isExpandedRegion">
                  <div class="title-container">
                    <span class="title">Region</span> <span class="count" *ngIf="selectedRegionCount>0">[
                      {{selectedRegionCount}} ] </span>
                  </div>
                  <div class="toggle-action-container">
                    <ng-container *ngIf="isExpandedRegion">
                      <button class="list-action-button" type="button"
                        (click)="$event.stopPropagation(); showSelectedRegionOnly = !showSelectedRegionOnly"
                        [matTooltip]="showSelectedRegionOnly ? 'Show All' : 'Show Selected Only'">
                        <mat-icon>{{ showSelectedRegionOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                      <button class="list-action-button" type="button"
                        (click)="$event.stopPropagation(); toggleSelectAllRegion()" matTooltip="Select All">
                        <mat-icon>{{ getSelectAllIconRegion() }}</mat-icon>
                      </button>
                    </ng-container>
                    <button class="list-action-button" type="button">
                      <mat-icon>{{ isExpandedRegion ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  </div>
                </div>

                <div *ngIf="isExpandedRegion" class="list">
                  <div class="item-list">
                    <div class="content-filter">
                      <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                        <input matInput placeholder="Filter regions" formControlName="regionFilterAll" />
                        <button *ngIf="editForm.get('regionFilterAll')?.value" matSuffix mat-icon-button
                          aria-label="Clear" (click)="editForm.get('regionFilterAll')?.setValue('')">
                          <mat-icon>close</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                    <div class="content">
                      <ng-container *ngFor="let item of filteredRegionListData">
                        <div class="list-item" (click)="item.selected = !item.selected; onRegionSelectionChange()">
                          <mat-checkbox color="primary" [checked]="item.selected" (click)="$event.stopPropagation()"
                            (change)="item.selected = !item.selected; onRegionSelectionChange()">
                            {{ item.item.name }}
                          </mat-checkbox>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>


              <div class="list-row area-manager" *ngIf="editForm.get('filtered_by')?.value === 'area_manager'">
                <div class="header" (click)="isExpandedAreaMgr = !isExpandedAreaMgr">
                  <div class="title-container">
                    <span class="title">Area Manager</span> <span class="count" *ngIf="selectedAreaMgrCount>0">[
                      {{selectedAreaMgrCount}} ] </span>
                  </div>
                  <div class="toggle-action-container">
                    <ng-container *ngIf="isExpandedAreaMgr">
                      <button class="list-action-button" type="button"
                        (click)="$event.stopPropagation(); showSelectedAreaMgrOnly = !showSelectedAreaMgrOnly"
                        [matTooltip]="showSelectedAreaMgrOnly ? 'Show All' : 'Show Selected Only'">
                        <mat-icon>{{ showSelectedAreaMgrOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                      <button class="list-action-button" type="button"
                        (click)="$event.stopPropagation(); toggleSelectAllAreaMgr()" matTooltip="Select All">
                        <mat-icon>{{ getSelectAllIconAreaMgr() }}</mat-icon>
                      </button>
                    </ng-container>
                    <button class="list-action-button" type="button">
                      <mat-icon>{{ isExpandedAreaMgr ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  </div>
                </div>

                <div *ngIf="isExpandedAreaMgr" class="list">
                  <div class="item-list">
                    <div class="content-filter">
                      <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                        <input matInput placeholder="Filter area managers" formControlName="areaMgrFilterAll" />
                        <button *ngIf="editForm.get('areaMgrFilterAll')?.value" matSuffix mat-icon-button
                          aria-label="Clear" (click)="editForm.get('areaMgrFilterAll')?.setValue('')">
                          <mat-icon>close</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                    <div class="content">
                      <ng-container *ngFor="let item of filteredAreaMgrListData">
                        <div class="list-item" (click)="item.selected = !item.selected; onAreaMgrSelectionChange()">
                          <mat-checkbox color="primary" [checked]="item.selected" (click)="$event.stopPropagation()"
                            (change)="item.selected = !item.selected; onAreaMgrSelectionChange()">
                            {{ item.item.name }}
                          </mat-checkbox>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>